/**
 * Cart "Generate PO" modal — logged-in customers only.
 * Copy comes from window.generateOrderLocale (theme locales / market language).
 * Primary delivery: Shopify contact form (store admin notification).
 * Secondary: FormSubmit (best-effort; failures do not block success).
 */
(function () {
  const modal = document.getElementById('GenerateOrderModal');
  const openButton = document.getElementById('GenerateOrderButton');
  if (!modal || !openButton) return;

  const locale = window.generateOrderLocale || {};
  const labels = locale.labels || {};
  const form = modal.querySelector('#GenerateOrderForm');
  const submitButton = form && form.querySelector('.generate-order-form__submit');
  const successEl = modal.querySelector('.generate-order-modal__success');
  const introEl = modal.querySelector('.generate-order-modal__intro');
  const fieldsWrap = modal.querySelector('.generate-order-form__fields');
  const countrySelect = document.getElementById('GenerateOrderCountry');
  const SALES_EMAIL = locale.salesEmail || 'sales@blackcatmusic.co.uk';

  if (!form || !submitButton) return;

  function isValid() {
    return Array.from(form.querySelectorAll('input[required], select[required]')).every(
      (field) => String(field.value || '').trim() !== ''
    );
  }

  function updateButtonState() {
    submitButton.disabled = !isValid();
  }

  function openModal() {
    modal.classList.remove('hidden');
    modal.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');
    updateButtonState();
    const firstEditable = form.querySelector('input:not([readonly]), select');
    if (firstEditable) firstEditable.focus();
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  function showSuccess() {
    if (successEl) {
      successEl.hidden = false;
    }
    if (introEl) introEl.hidden = true;
    if (fieldsWrap) fieldsWrap.hidden = true;
    submitButton.hidden = true;
  }

  function buildCartSummary() {
    const bodyField = form.querySelector('.generate-order-form__cart-body');
    return (bodyField && bodyField.value) || '';
  }

  function contactUrl() {
    if (form && form.getAttribute('action')) {
      return form.getAttribute('action');
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'contact';
  }

  function selectDefaultCountry() {
    if (!countrySelect) return;
    const defaultCountry = (countrySelect.getAttribute('data-default') || '').trim();
    if (!defaultCountry) return;

    const normalized = defaultCountry.toLowerCase();
    const options = Array.from(countrySelect.options);
    const match = options.find((opt) => {
      const value = (opt.value || '').trim().toLowerCase();
      const text = (opt.textContent || '').trim().toLowerCase();
      return value === normalized || text === normalized;
    });
    if (match) {
      countrySelect.value = match.value;
      options.forEach((opt) => {
        opt.selected = opt === match;
      });
    }
  }

  openButton.addEventListener('click', function (event) {
    event.preventDefault();
    if (openButton.disabled) return;
    openModal();
  });

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-generate-order-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });

  form.addEventListener('input', updateButtonState);
  form.addEventListener('change', updateButtonState);

  selectDefaultCountry();
  updateButtonState();

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (!isValid()) return;

    const originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = locale.submitting || 'Submitting...';

    const formData = new FormData(form);
    const name = (formData.get('contact[name]') || '').trim();
    const email = (formData.get('contact[email]') || '').trim();
    const address = (formData.get('contact[address]') || '').trim();
    const city = (formData.get('contact[city]') || '').trim();
    const province = (formData.get('contact[province]') || '').trim();
    const zip = (formData.get('contact[zip]') || '').trim();
    const country = (formData.get('contact[country]') || '').trim();
    const cartSummary = buildCartSummary();

    const labelName = labels.name || 'Name';
    const labelEmail = labels.email || 'Email';
    const labelAddress = labels.address || 'Address';
    const labelCity = labels.city || 'City';
    const labelProvince = labels.province || 'State / Province';
    const labelZip = labels.zip || 'ZIP / Postal Code';
    const labelCountry = labels.country || 'Country';
    const labelCart = labels.cart || 'Cart';

    const detailsBlock = [
      `${labelName}: ${name}`,
      `${labelEmail}: ${email}`,
      `${labelAddress}: ${address}`,
      `${labelCity}: ${city}`,
      `${labelProvince}: ${province}`,
      `${labelZip}: ${zip}`,
      `${labelCountry}: ${country}`,
      '',
      cartSummary.trim(),
    ].join('\n');

    const bodyField = form.querySelector('.generate-order-form__cart-body');
    if (bodyField) {
      bodyField.value = detailsBlock;
    }

    const subjectTemplate = locale.emailSubject || 'Generate PO Request – __NAME__';
    const subject = subjectTemplate.replace('__NAME__', name);

    const shopifyData = new FormData(form);
    shopifyData.set('contact[body]', detailsBlock);
    if (!shopifyData.get('contact[email]')) {
      shopifyData.set('contact[email]', email);
    }

    const fsData = new FormData();
    fsData.append('_subject', subject);
    fsData.append('_template', 'table');
    fsData.append('_replyto', email);
    fsData.append(labelName, name);
    fsData.append(labelEmail, email);
    fsData.append(labelAddress, address);
    fsData.append(labelCity, city);
    fsData.append(labelProvince, province);
    fsData.append(labelZip, zip);
    fsData.append(labelCountry, country);
    fsData.append(labelCart, cartSummary);

    let shopifyOk = false;

    try {
      const shopifyResponse = await fetch(contactUrl(), {
        method: 'POST',
        body: shopifyData,
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      });
      // Shopify contact posts typically return 200 (redirects are followed by fetch)
      shopifyOk = shopifyResponse.ok;
    } catch (shopifyError) {
      console.error('Generate PO Shopify contact error:', shopifyError);
    }

    // Best-effort admin copy via FormSubmit — never required for success
    try {
      await fetch(`https://formsubmit.co/ajax/${SALES_EMAIL}`, {
        method: 'POST',
        body: fsData,
        headers: { Accept: 'application/json' },
      });
    } catch (fsError) {
      console.warn('Generate PO FormSubmit skipped/failed:', fsError);
    }

    if (shopifyOk) {
      showSuccess();
      return;
    }

    // Last resort: native form post (page will reload with contact success)
    try {
      form.submit();
    } catch (nativeError) {
      console.error('Generate PO error:', nativeError);
      submitButton.disabled = false;
      submitButton.textContent = originalText;
      alert(locale.error || 'Sorry, something went wrong. Please try again or contact us directly.');
    }
  });
})();
